const CRUMBS = [
  { label: "Home", href: "/" },
  { label: "Adani Shantigram", href: "/adani-shantigram" },
];

export const PROJECT_PAGES = [
  {
    slug: "the-storeys",
    path: "/adani-shantigram/the-storeys",
    title: "The Storeys Shantigram | 4 & 5 BHK Homes, ₹4.26 Cr Onwards | VR Ahmedabad Realtors",
    meta: "The Storeys, Adani Shantigram — 4 & 5 BHK single-storeyed and duplex homes, 3541–5998 sq ft, ₹4.26 Cr onwards, ready to move on the golf course. Site visits with VR Ahmedabad Realtors.",
    kicker: "Ready to Move · Golf Course Towers",
    h1: "The Storeys Shantigram – Luxury 4 & 5 BHK Residences",
    project: "The Storeys",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-storeys/carousel-images/outdoor/the-storey-1.ashx",
    intro: [
      "The Storeys is Gujarat's first vertical development on a golf course — 4 and 5 BHK single-storeyed homes and duplex residences from 3541 to 5998 sq. ft., priced from ₹4.26 crore onwards, and ready to move.",
      "These are platinum pre-certified green homes with 23-ft ceilings in the duplexes, private foyers and complimentary membership of the Belvedere Golf & Country Club.",
    ],
    sections: [
      {
        h2: "Configurations",
        bullets: ["4 BHK single-storeyed residences", "5 BHK single-storeyed and duplex homes", "Sizes from approximately 3541 to 5998 sq. ft."],
      },
      {
        h2: "Key features",
        bullets: [
          "Gujarat's first pre-certified platinum-rated homes on a golf course",
          "23-ft high ceilings in duplex residences",
          "Private foyers and white glove services",
          "Complimentary Belvedere Golf & Country Club membership",
        ],
      },
      {
        h2: "Amenities",
        bullets: ["Double-height infinity pool", "Skydeck on the terrace", "Children's outdoor play area", "Private foyer access"],
      },
      {
        h2: "Availability and pricing",
        paras: ["The Storeys is completed with immediate possession, priced from ₹4.26 crore onwards. Tower, floor and view move pricing meaningfully — ask us for the live availability sheet and current resale listings in the project."],
      },
    ],
    projects: ["The Storeys", "The Storeys Infinity", "The Storeys Golf Coast"],
    faqs: [
      { q: "What is the price of The Storeys in Shantigram?", a: "Homes at The Storeys start from ₹4.26 crore onwards, depending on configuration, floor and view. Contact us for the current price sheet and available units." },
      { q: "Is The Storeys ready to move?", a: "Yes — The Storeys is completed with immediate possession. The Storeys Infinity and The Storeys Golf Coast are its under-construction successors." },
      { q: "What makes The Storeys special?", a: "It is Gujarat's first pre-certified platinum-rated residential development built on a golf course, with 23-ft ceiling duplexes and white glove services." },
    ],
    related: [
      { label: "4 BHK flats in Adani Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "5 BHK homes in Adani Shantigram", href: "/adani-shantigram-5-bhk" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "the-storeys-infinity",
    path: "/adani-shantigram/the-storeys-infinity",
    title: "The Storeys Infinity Shantigram | 4 BHK & 5 BHK Penthouses | VR Ahmedabad Realtors",
    meta: "The Storeys Infinity, Adani Shantigram — 4 BHK apartments 2422–5019 sq ft & 5 BHK penthouses from ₹3.5 Cr onwards. Canal and golf views, private lift foyers. VR Ahmedabad Realtors.",
    kicker: "Under Construction · Canal & Golf Views",
    h1: "The Storeys Infinity Shantigram – 4 BHK Residences & 5 BHK Penthouses",
    project: "The Storeys Infinity",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-storeys-infinity/gallery/01.ashx",
    intro: [
      "The Storeys Infinity extends the Storeys legacy — 4 BHK apartments from 2422 to 5019 sq. ft. and 5 BHK penthouses of about 5019 sq. ft., priced from ₹3.5 crore onwards.",
      "Homes are designed column-less for layout freedom, with 11-foot slab heights, private lift foyers, attached staff quarters and unobstructed dual views of the Narmada canal and the golf course.",
    ],
    sections: [
      {
        h2: "Configurations",
        bullets: ["4 BHK apartments — 2422 to 5019 sq. ft.", "5 BHK penthouses — approximately 5019 sq. ft."],
      },
      {
        h2: "Key features",
        bullets: [
          "Unobstructed views of the Narmada canal and golf course",
          "Column-less design for layout freedom",
          "11-foot slab heights and private lift foyers",
          "Attached staff quarters",
        ],
      },
      {
        h2: "Amenities",
        bullets: ["Indoor swimming pool", "Gymnasium and indoor games room", "Business centre", "Theatre and multipurpose hall", "Children's play area"],
      },
      {
        h2: "Availability and pricing",
        paras: ["The Storeys Infinity is under construction with pricing from ₹3.5 crore onwards. Under-construction purchase brings launch-stage pricing and payment plans — ask us for the current schedule and floor availability."],
      },
    ],
    projects: ["The Storeys Infinity", "The Storeys", "The Storeys Golf Coast"],
    faqs: [
      { q: "What is the price of The Storeys Infinity?", a: "Pricing starts from ₹3.5 crore onwards, varying by configuration, floor and view. Contact us for the current price sheet and payment plan." },
      { q: "Is The Storeys Infinity ready to move?", a: "No — it is under construction. For a completed Storeys address, consider The Storeys, which is ready to move." },
      { q: "What views does The Storeys Infinity offer?", a: "Homes enjoy unobstructed dual views of the Narmada canal and the Shantigram golf course." },
    ],
    related: [
      { label: "The Storeys — ready to move", href: "/adani-shantigram/the-storeys" },
      { label: "Penthouses in Adani Shantigram", href: "/adani-shantigram-penthouses" },
      { label: "4 BHK flats in Adani Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "the-storeys-golf-coast",
    path: "/adani-shantigram/the-storeys-golf-coast",
    title: "The Storeys Golf Coast Shantigram | 4 BHK Simplex & 5 BHK Duplex | VR Ahmedabad Realtors",
    meta: "The Storeys Golf Coast, Adani Shantigram — 4 BHK simplex & 5 BHK duplex homes, 3501–6466 sq ft, single floor single home, golf & canal views. Price on request. VR Ahmedabad Realtors.",
    kicker: "New Launch · Single Floor, Single Home",
    h1: "The Storeys Golf Coast Shantigram – 4 & 5 BHK Golf-Facing Homes",
    project: "The Storeys Golf Coast",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-storeys-golf-coast/banner-(1).ashx",
    intro: [
      "The Storeys Golf Coast is Shantigram's newest signature address — 4 BHK simplex and 5 BHK duplex residences from 3501 to 6466 sq. ft., built around the idea of a single home per floor.",
      "Every residence faces the golf course or the Narmada canal, backed by white glove services and a full amenity deck. Pricing is available on request.",
    ],
    sections: [
      {
        h2: "Configurations",
        bullets: ["4 BHK simplex residences", "5 BHK duplex residences", "Sizes from approximately 3501 to 6466 sq. ft."],
      },
      {
        h2: "Key features",
        bullets: [
          "Single floor, single home living",
          "Unobstructed golf course and Narmada canal views",
          "White glove services",
          "Double-height living in duplex formats",
        ],
      },
      {
        h2: "Amenities",
        bullets: ["Double-height swimming pool", "Gymnasium and yoga studio", "Salon and business centre", "Theatre and indoor games zone", "Multipurpose room"],
      },
      {
        h2: "Availability and pricing",
        paras: ["The Storeys Golf Coast is under construction with pricing on request. Launch-stage buyers typically secure the best floors and payment terms — contact us for the current price sheet and possession timeline."],
      },
    ],
    projects: ["The Storeys Golf Coast", "The Storeys", "The Storeys Infinity"],
    faqs: [
      { q: "What is the price of The Storeys Golf Coast?", a: "Pricing is available on request and varies by tower, floor and view. Contact VR Ahmedabad Realtors for the current price sheet, payment plan and launch offers." },
      { q: "What configurations are available at The Storeys Golf Coast?", a: "4 BHK simplex and 5 BHK duplex residences ranging from approximately 3501 to 6466 sq. ft." },
      { q: "When will The Storeys Golf Coast be ready?", a: "The project is currently under construction. Ask us for the latest possession timeline and construction updates for your preferred tower." },
    ],
    related: [
      { label: "5 BHK homes in Adani Shantigram", href: "/adani-shantigram-5-bhk" },
      { label: "4 BHK flats in Adani Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "paarijat",
    path: "/adani-shantigram/paarijat",
    title: "Paarijat Shantigram | 4 BHK Premium Homes, Ready to Move | VR Ahmedabad Realtors",
    meta: "Paarijat, Adani Shantigram — 4 BHK premium homes, ready to move inside the 600-acre township. Availability, pricing & site visits with VR Ahmedabad Realtors.",
    kicker: "Ready to Move · 4 BHK",
    h1: "Paarijat Shantigram – Premium 4 BHK Homes",
    project: "Paarijat",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/paarijat/thumbnails/thumbnail.ashx",
    intro: [
      "Paarijat offers premium 4 BHK homes in one of Shantigram's completed, occupied clusters — a ready-to-move address for families who want township living without the construction wait.",
      "Residents enjoy the township's full amenity ecosystem — golf course, lake, club, sports academy and 24×7 security — with possession available immediately.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["4 BHK premium residences"] },
      {
        h2: "Why buyers choose Paarijat",
        bullets: ["Ready to move with immediate possession", "Established, occupied community", "Full township amenity access", "Strong resale and rental liquidity"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Paarijat is completed. Pricing and detailed specifications are shared on request — we provide the live availability sheet, floor plans and any current resale units in the cluster."],
      },
    ],
    projects: ["Paarijat", "The Storeys", "La Marina"],
    faqs: [
      { q: "Is Paarijat Shantigram ready to move?", a: "Yes — Paarijat is a completed cluster with immediate possession available." },
      { q: "What is the price of 4 BHK homes in Paarijat?", a: "Pricing is shared on request and varies by floor and view. Contact us for the current availability sheet and comparable resale transactions." },
      { q: "Are resale units available in Paarijat?", a: "Yes, owner-listed resale units come up in Paarijat — ask us for current verified listings." },
    ],
    related: [
      { label: "4 BHK flats in Adani Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Resale flats in Shantigram", href: "/adani-shantigram-resale" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "la-marina",
    path: "/adani-shantigram/la-marina",
    title: "La Marina Shantigram | 4 & 5 BHK Waterfront Penthouses | VR Ahmedabad Realtors",
    meta: "La Marina, Adani Shantigram — 4 BHK residences & 5 BHK waterfront penthouses, ready to move. Penthouse decks and golf-side living. Enquire with VR Ahmedabad Realtors.",
    kicker: "Ready to Move · Waterfront",
    h1: "La Marina Shantigram – 4 & 5 BHK Waterfront Penthouses",
    project: "La Marina",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/la-marina/carousel-images/thumbnail-image/thumbnail.ashx",
    intro: [
      "La Marina is Shantigram's waterfront address — 4 BHK residences and 4 & 5 BHK penthouses with generous decks, completed and ready to move.",
      "It suits buyers who want penthouse-scale living with immediate possession inside the township's premium belt.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["4 BHK residences", "4 & 5 BHK penthouses"] },
      {
        h2: "Why buyers choose La Marina",
        bullets: ["Waterfront setting inside the township", "Penthouse decks and elevated views", "Ready to move with immediate possession", "Golf-side township address"],
      },
      {
        h2: "Availability and pricing",
        paras: ["La Marina is completed. Pricing is shared on request — penthouse values depend heavily on floor and view, so ask us for the live availability sheet and recent comparable transactions."],
      },
    ],
    projects: ["La Marina", "Water Lily", "The Storeys"],
    faqs: [
      { q: "Is La Marina ready to move?", a: "Yes — La Marina is completed with immediate possession." },
      { q: "What configurations does La Marina offer?", a: "4 BHK residences and 4 & 5 BHK waterfront penthouses." },
      { q: "What is the price of La Marina penthouses?", a: "Penthouse pricing is on request and varies by floor and view. Contact us for current availability." },
    ],
    related: [
      { label: "Penthouses in Adani Shantigram", href: "/adani-shantigram-penthouses" },
      { label: "5 BHK homes in Adani Shantigram", href: "/adani-shantigram-5-bhk" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "water-lily",
    path: "/adani-shantigram/water-lily",
    title: "Water Lily Shantigram | 5 BHK Duplex Penthouses | VR Ahmedabad Realtors",
    meta: "Water Lily, Adani Shantigram — 5 BHK duplex penthouses, ready to move, with township greens and pool amenities. Availability & pricing with VR Ahmedabad Realtors.",
    kicker: "Ready to Move · Duplex Penthouses",
    h1: "Water Lily Shantigram – 5 BHK Duplex Penthouses",
    project: "Water Lily",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/water-lily/thumbnail.ashx",
    intro: [
      "Water Lily is Shantigram's duplex penthouse address — 5 BHK residences across two levels, completed and ready to move.",
      "Double-height living, private terraces and the township's greens below make it a favourite among buyers upgrading from large apartments to penthouse-scale homes.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["5 BHK duplex penthouses"] },
      {
        h2: "Why buyers choose Water Lily",
        bullets: ["Duplex penthouse formats with double-height living", "Private terraces", "Ready to move with immediate possession", "Lake-side township greens and pool amenities"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Water Lily is completed. Pricing is shared on request — duplex penthouses price off view and level, so contact us for current availability and recent transactions in the project."],
      },
    ],
    projects: ["Water Lily", "La Marina", "The Storeys Infinity"],
    faqs: [
      { q: "Is Water Lily ready to move?", a: "Yes — Water Lily is completed with immediate possession." },
      { q: "What configurations does Water Lily offer?", a: "Water Lily offers 5 BHK duplex penthouses." },
      { q: "What is the price of Water Lily penthouses?", a: "Pricing is on request and varies by level and view. Ask us for the current availability sheet." },
    ],
    related: [
      { label: "Penthouses in Adani Shantigram", href: "/adani-shantigram-penthouses" },
      { label: "5 BHK homes in Adani Shantigram", href: "/adani-shantigram-5-bhk" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "aster-neo",
    path: "/adani-shantigram/aster-neo",
    title: "Aster NEO Shantigram | 2 BHK Smartments, Ready to Move | VR Ahmedabad Realtors",
    meta: "Aster NEO, Adani Shantigram — 2 BHK #Smartments with home automation, vanishing-edge pool & ~70% open greens. Ready to move. Price & floor plans with VR Ahmedabad Realtors.",
    kicker: "Ready to Move · 2 BHK Smart Homes",
    h1: "Aster NEO Shantigram – 2 BHK Smartments",
    project: "Aster NEO",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/aster-neo/1920x1080/1920x1080-cam_03-n.ashx",
    intro: [
      "Aster NEO brings Shantigram's smartest 2 BHK homes — app-controlled automation, a vanishing-edge swimming pool, a multi-storey clubhouse and roughly 70% open green space around the towers.",
      "Completed and ready to move, Aster NEO is the township's most popular entry point for first-time buyers and rental investors alike.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["2 BHK #Smartments with home automation"] },
      {
        h2: "Key features",
        bullets: ["Smart home automation", "Vanishing-edge swimming pool", "Multi-storey clubhouse", "Approximately 70% open green space around the towers"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Aster NEO is completed and ready to move. 2 BHK pricing in this band typically runs ₹60–90 lakh depending on floor and view — ask us for the live availability sheet and any resale units in the cluster."],
      },
    ],
    projects: ["Aster NEO", "Resale Units", "Embrace"],
    faqs: [
      { q: "What is the price of Aster NEO 2 BHK?", a: "2 BHK homes at Aster NEO are priced in the township's entry band — typically ₹60–90 lakh depending on floor and view. Ask us for current developer and resale availability." },
      { q: "What are #Smartments at Aster NEO?", a: "Smartments are Aster NEO's smart homes — lighting, climate and security controlled from your phone, alongside township amenities like the vanishing-edge pool." },
      { q: "Is Aster NEO good for rental income?", a: "Yes — 2 BHK units in Aster NEO see some of the deepest tenant demand in Shantigram, with indicative rents of ₹25,000–40,000 per month." },
    ],
    related: [
      { label: "2 BHK flats in Adani Shantigram", href: "/adani-shantigram-2-bhk" },
      { label: "Rental flats in Shantigram", href: "/adani-shantigram-rent" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "the-west-park",
    path: "/adani-shantigram/the-west-park",
    title: "The West Park Shantigram | Ready-to-Move Luxury Villas | VR Ahmedabad Realtors",
    meta: "The West Park, Adani Shantigram — ready-to-move luxury villas in a gated enclave with township club access. Availability & pricing with VR Ahmedabad Realtors.",
    kicker: "Ready to Move · Villas",
    h1: "The West Park Shantigram – Ready-to-Move Villas",
    project: "The West Park",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/west-park/highlight/adobestock_633152870.ashx",
    intro: [
      "The West Park is Shantigram's ready-to-move villa enclave — independent luxury homes inside the township's 600-acre secured master plan.",
      "For buyers who want villa privacy without waiting on construction, The West Park is the township's immediate answer.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["Independent luxury villas"] },
      {
        h2: "Why buyers choose The West Park",
        bullets: ["Ready to move with immediate possession", "Gated villa enclave privacy", "Township club and amenity access", "Independent-home living with township security"],
      },
      {
        h2: "Availability and pricing",
        paras: ["The West Park is completed. Villa pricing depends on plot and specification and is shared on request — contact us for current availability."],
      },
    ],
    projects: ["The West Park", "The North Park", "Belrosa"],
    faqs: [
      { q: "Are West Park villas ready to move?", a: "Yes — The West Park is a completed villa enclave with immediate possession." },
      { q: "What is the price of West Park villas?", a: "Villa pricing is on request and depends on plot and specification. Contact us for current availability." },
      { q: "How is The West Park different from The North Park?", a: "The West Park is completed and ready to move; The North Park is the township's newer villa enclave, currently under construction." },
    ],
    related: [
      { label: "Villas in Adani Shantigram", href: "/adani-shantigram-villas" },
      { label: "The North Park project page", href: "/adani-shantigram/the-north-park" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "ambrosia",
    path: "/adani-shantigram/ambrosia",
    title: "Ambrosia Shantigram | 4 BHK Ultra-Luxury Apartments | VR Ahmedabad Realtors",
    meta: "Ambrosia, Adani Shantigram — 4 BHK ultra-luxury apartments, under construction with launch-stage pricing. Floor plans & payment plans with VR Ahmedabad Realtors.",
    kicker: "Under Construction · Ultra-Luxury",
    h1: "Ambrosia Shantigram – 4 BHK Ultra-Luxury Apartments",
    project: "Ambrosia",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/ambrosia/thumbnails/thumbnail-1.ashx",
    intro: [
      "Ambrosia is Shantigram's ultra-luxury 4 BHK offering — a signature tower for buyers who want the township's premium belt at launch-stage pricing.",
      "Under construction today, Ambrosia suits buyers with time on their side who want newer specifications and construction-linked payment plans.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["4 BHK ultra-luxury apartments"] },
      {
        h2: "Why buyers consider Ambrosia",
        bullets: ["Ultra-luxury specifications", "Signature tower positioning", "Launch-stage pricing and payment plans", "Full township amenity access"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Ambrosia is under construction with pricing on request. Ask us for the current price sheet, floor plans and payment schedule."],
      },
    ],
    projects: ["Ambrosia", "Skyline", "The Storeys Infinity"],
    faqs: [
      { q: "What is the price of Ambrosia Shantigram?", a: "Pricing is on request at this stage. Contact us for the current price sheet and launch offers." },
      { q: "When will Ambrosia be ready?", a: "Ambrosia is under construction — ask us for the latest possession timeline for your preferred tower." },
      { q: "What configurations does Ambrosia offer?", a: "Ambrosia offers 4 BHK ultra-luxury apartments." },
    ],
    related: [
      { label: "4 BHK flats in Adani Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
      { label: "Luxury properties in Ahmedabad", href: "/luxury-properties-ahmedabad" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "the-north-park",
    path: "/adani-shantigram/the-north-park",
    title: "The North Park Shantigram | 4 BHK Villas with Private Gardens | VR Ahmedabad Realtors",
    meta: "The North Park, Adani Shantigram — 4 BHK luxury villas with private gardens, select private pools & exclusive club access. Under construction. Enquire with VR Ahmedabad Realtors.",
    kicker: "Under Construction · Villa Enclave",
    h1: "The North Park Shantigram – 4 BHK Luxury Villas",
    project: "The North Park",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/the-north-park/exterior/exterior/villa-b-street-view-1.ashx",
    intro: [
      "The North Park is Shantigram's newest villa crown — 4 BHK independent homes with private gardens, select residences with private pools, and access to an exclusive club.",
      "Set inside the township's gated master plan, it combines independent-home privacy with golf-course-and-lake township living.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["4 BHK luxury villas"] },
      {
        h2: "Key features",
        bullets: ["Private gardens", "Select villas with private pools", "Exclusive club access", "Gated villa enclave inside the township"],
      },
      {
        h2: "Availability and pricing",
        paras: ["The North Park is under construction with villa pricing on request. Early buyers secure preferred plots — ask us for the current availability map and price list."],
      },
    ],
    projects: ["The North Park", "The West Park", "Belrosa"],
    faqs: [
      { q: "What is the price of North Park villas in Shantigram?", a: "Villa pricing at The North Park is on request and depends on plot, size and specification. Contact us for the current price list and available villas." },
      { q: "When will The North Park be ready?", a: "The North Park is currently under construction. For ready-to-move villa living, The West Park is completed — ask us for a comparison." },
      { q: "Do North Park villas have private pools?", a: "Select villas offer private pools and gardens, and all residents enjoy the enclave's exclusive club and the wider township amenities." },
    ],
    related: [
      { label: "Villas in Adani Shantigram", href: "/adani-shantigram-villas" },
      { label: "The West Park — ready villas", href: "/adani-shantigram/the-west-park" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Luxury properties in Ahmedabad", href: "/luxury-properties-ahmedabad" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "belrosa",
    path: "/adani-shantigram/belrosa",
    title: "Belrosa Shantigram | 4 & 5 BHK Apartments, 5 & 6 BHK Duplexes | VR Ahmedabad Realtors",
    meta: "Belrosa, Adani Shantigram — 4 & 5 BHK apartments and 5 & 6 BHK duplex residences, under construction. Canal-facing grand homes. Enquire with VR Ahmedabad Realtors.",
    kicker: "Under Construction · Grand Duplexes",
    h1: "Belrosa Shantigram – 4 & 5 BHK Apartments, 5 & 6 BHK Duplexes",
    project: "Belrosa",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/belrosa/exterior/entrance-gate-view.ashx",
    intro: [
      "Belrosa brings grand-scale living to Shantigram — 4 and 5 BHK apartments alongside 5 and 6 BHK duplex residences for buyers who want villa scale in the sky.",
      "Under construction with launch-stage pricing, Belrosa suits large families and buyers upgrading to the township's biggest formats.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["4 & 5 BHK apartments", "5 & 6 BHK duplex residences"] },
      {
        h2: "Why buyers consider Belrosa",
        bullets: ["The township's largest apartment formats", "Grand duplex layouts", "Canal-facing positioning", "Premium clubhouse and amenity access"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Belrosa is under construction with pricing on request. Ask us for the current price sheet, floor plans and payment schedule."],
      },
    ],
    projects: ["Belrosa", "The Storeys Golf Coast", "The North Park"],
    faqs: [
      { q: "What configurations does Belrosa offer?", a: "Belrosa offers 4 & 5 BHK apartments and 5 & 6 BHK duplex residences." },
      { q: "What is the price of Belrosa Shantigram?", a: "Pricing is on request at this stage. Contact us for the current price sheet and launch offers." },
      { q: "When will Belrosa be ready?", a: "Belrosa is under construction — ask us for the latest possession timeline." },
    ],
    related: [
      { label: "5 BHK homes in Adani Shantigram", href: "/adani-shantigram-5-bhk" },
      { label: "Villas in Adani Shantigram", href: "/adani-shantigram-villas" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "skyline",
    path: "/adani-shantigram/skyline",
    title: "Skyline Shantigram | 4 BHK Uberments | VR Ahmedabad Realtors",
    meta: "Skyline, Adani Shantigram — 4 BHK Uberments, the township's uber-luxury sky residences, under construction. Floor plans & pricing with VR Ahmedabad Realtors.",
    kicker: "Under Construction · Uberments",
    h1: "Skyline Shantigram – 4 BHK Uberments",
    project: "Skyline",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/skyline/gallary-image/skyline-1-(1).ashx",
    intro: [
      "Skyline introduces the Uberment to Shantigram — 4 BHK sky residences positioned above the township with panoramic views.",
      "Under construction with launch-stage pricing, Skyline targets buyers who want the newest specifications in a high-rise format.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["4 BHK Uberments"] },
      {
        h2: "Why buyers consider Skyline",
        bullets: ["Uber-luxury sky residence format", "Panoramic township views", "Newest specifications in the township", "Launch-stage pricing and payment plans"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Skyline is under construction with pricing on request. Ask us for the current price sheet, floor plans and payment schedule."],
      },
    ],
    projects: ["Skyline", "Ambrosia", "The Storeys Infinity"],
    faqs: [
      { q: "What is an Uberment at Skyline?", a: "Uberment is Skyline's term for its uber-luxury 4 BHK sky residences — premium high-rise homes with panoramic views." },
      { q: "What is the price of Skyline Shantigram?", a: "Pricing is on request at this stage. Contact us for the current price sheet." },
      { q: "When will Skyline be ready?", a: "Skyline is under construction — ask us for the latest possession timeline." },
    ],
    related: [
      { label: "4 BHK flats in Adani Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
      { label: "Luxury properties in Ahmedabad", href: "/luxury-properties-ahmedabad" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "embrace",
    path: "/adani-shantigram/embrace",
    title: "Embrace Shantigram | 3 BHK Lifestyle Homes | VR Ahmedabad Realtors",
    meta: "Embrace, Adani Shantigram — 3 BHK lifestyle homes with gymnasium, seating alcoves & multipurpose lawns, under construction. Pricing & floor plans with VR Ahmedabad Realtors.",
    kicker: "Under Construction · 3 BHK Lifestyle",
    h1: "Embrace Shantigram – 3 BHK Lifestyle Homes",
    project: "Embrace",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/embrace/optimize-exterior-jpg/1920x1080-exterior/1920x1080-birds-eye-view.ashx",
    intro: [
      "Embrace is Shantigram's 3 BHK lifestyle address — family-sized homes with a gymnasium, seating alcoves and multipurpose lawns built for everyday community living.",
      "Under construction with payment plans, Embrace suits families entering the township at the 3 BHK scale.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["3 BHK lifestyle homes"] },
      {
        h2: "Key features",
        bullets: ["Gymnasium", "Seating alcoves", "Multipurpose lawns", "Family-oriented community planning"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Embrace is under construction. 3 BHK pricing in Shantigram typically runs ₹1–2 crore depending on cluster and view — ask us for Embrace's current price sheet and payment plan."],
      },
    ],
    projects: ["Embrace", "Greenfield", "Aster NEO"],
    faqs: [
      { q: "What is the price of Embrace 3 BHK homes?", a: "3 BHK homes in Shantigram typically range ₹1–2 crore. Contact us for Embrace's current price sheet and payment plan." },
      { q: "When will Embrace be ready?", a: "Embrace is under construction — ask us for the latest possession timeline." },
      { q: "Who is Embrace best suited for?", a: "Families entering township living at the 3 BHK scale, and buyers wanting community amenities like lawns and gymnasium access." },
    ],
    related: [
      { label: "3 BHK flats in Adani Shantigram", href: "/adani-shantigram-3-bhk" },
      { label: "Greenfield project page", href: "/adani-shantigram/greenfield" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "greenfield",
    path: "/adani-shantigram/greenfield",
    title: "Greenfield Shantigram | 3 BHK Apartments & 4 BHK Penthouses | VR Ahmedabad Realtors",
    meta: "Greenfield, Adani Shantigram — 3 BHK apartments & 4 BHK penthouses with 270° open views, under construction. Pricing & floor plans with VR Ahmedabad Realtors.",
    kicker: "Under Construction · 270° Views",
    h1: "Greenfield Shantigram – 3 BHK Homes & 4 BHK Penthouses",
    project: "Greenfield",
    ogImage: "https://www.adanirealty.com/-/media/project/realty/residential/ahmedabad/shivalik-greenfiled/render-images/cam-11_11zon.ashx",
    intro: [
      "Greenfield pairs 3 BHK apartments with a 4 BHK penthouse collection, designed around 270-degree open views over the township's greens.",
      "Under construction with payment plans, it suits buyers who prioritise light, air and views in a family-sized format.",
    ],
    sections: [
      { h2: "Configurations", bullets: ["3 BHK apartments", "4 BHK penthouses"] },
      {
        h2: "Key features",
        bullets: ["270-degree open views", "Penthouse collection", "Green, open-plan living", "Township amenity access"],
      },
      {
        h2: "Availability and pricing",
        paras: ["Greenfield is under construction with pricing on request. Ask us for the current price sheet, view stacks and payment schedule."],
      },
    ],
    projects: ["Greenfield", "Embrace", "Resale Units"],
    faqs: [
      { q: "What is the price of Greenfield Shantigram?", a: "Pricing is on request at this stage. Contact us for the current price sheet for 3 BHK apartments and 4 BHK penthouses." },
      { q: "When will Greenfield be ready?", a: "Greenfield is under construction — ask us for the latest possession timeline." },
      { q: "What is special about Greenfield's views?", a: "Homes are designed around 270-degree open views over the township's greens — rare for this configuration band." },
    ],
    related: [
      { label: "3 BHK flats in Adani Shantigram", href: "/adani-shantigram-3-bhk" },
      { label: "Penthouses in Adani Shantigram", href: "/adani-shantigram-penthouses" },
      { label: "Adani Shantigram overview", href: "/adani-shantigram" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
    ],
    crumbs: CRUMBS,
  },
  {
    slug: "resale-properties",
    path: "/adani-shantigram/resale-properties",
    title: "Resale Properties in Adani Shantigram | Verified Owner Listings | VR Ahmedabad Realtors",
    meta: "Resale properties in Adani Shantigram — verified owner-listed 2–5 BHK flats, penthouses & villas across completed clusters. Title-checked units with VR Ahmedabad Realtors.",
    kicker: "The Resale Desk",
    h1: "Resale Properties in Adani Shantigram",
    project: "Resale Units",
    intro: [
      "Our resale desk tracks owner-listed units across Shantigram's completed clusters — from 2 BHK apartments in Aster and Aangan to penthouses in La Marina and Water Lily.",
      "Every listing is verified for title, society NOC status and dues before we present it, and priced against live comparable transactions in the same cluster.",
    ],
    sections: [
      {
        h2: "What the resale desk handles",
        bullets: [
          "Verified owner-listed flats, penthouses and villas",
          "Title, NOC and dues verification before presentation",
          "Price benchmarking against recent cluster transactions",
          "Negotiation, loan coordination and registration support",
          "Seller representation — genuine price discovery for your unit",
        ],
      },
      {
        h2: "For sellers",
        paras: [
          "Selling in Shantigram? We price your unit to the live market, present it to qualified buyers — including NRI purchasers — and manage the transaction through registration. Ask for a no-obligation valuation of your property.",
        ],
      },
    ],
    projects: ["Resale Units", "Aster NEO", "Paarijat", "La Marina"],
    faqs: [
      { q: "How do I list my Shantigram property for resale?", a: "Call or WhatsApp +91 90160 75761 with your unit details. We'll assess the live market value and explain our seller process before listing." },
      { q: "Are resale transactions safe in Shantigram?", a: "With verification, yes. We check title, society NOC and dues on every unit before presentation, and completed clusters are approved by major banks." },
      { q: "Which clusters have the most resale inventory?", a: "Aster, Aangan, Pratham, The Meadows and Paarijat see the most resale activity, with premium units appearing in La Marina, Water Lily and The Storeys less frequently." },
    ],
    related: [
      { label: "Resale flats in Shantigram — overview", href: "/adani-shantigram-resale" },
      { label: "Guide to buying resale property", href: "/insights/guide-to-buying-resale-property-in-ahmedabad" },
      { label: "Ready-to-move homes in Shantigram", href: "/adani-shantigram-ready-to-move" },
      { label: "Adani Shantigram price list", href: "/adani-shantigram-price" },
    ],
    crumbs: CRUMBS,
  },
];
